import { render, staticRenderFns } from "./TenderCard.vue?vue&type=template&id=433bd528&"
import script from "./TenderCard.vue?vue&type=script&lang=js&"
export * from "./TenderCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports